import React, { FC } from 'react';
import { makeStyles } from '@mui/styles';
import { LoadingScreenProps } from './LoadingScreenProps';
import Stack from '@mui/material/Stack';

import Loading, { LoadingBall } from '@ingka/loading';
const useStyles = makeStyles(() => ({
  loadingContainer: {
    justifyContent: 'center',
    margin: 'auto',
  },
}));

const LoadingScreen: FC<LoadingScreenProps> = ({ message }) => {
  const classes = useStyles();

  return (
    <Stack
      className={classes.loadingContainer}
      data-testid={'spinner'}
      height={'100%'}
    >
      <Loading text={message}>
        <LoadingBall />
      </Loading>
    </Stack>
  );
};

export default LoadingScreen;
